const getClientSettings = async (clientId) => {
  if (!clientId) {
    throw new Error('invalid clientId')
  }
  
  // eslint-disable-next-line no-undef
  const url = `${WEB_BFF_URL}/v1/clients/${clientId}/settings`
  const headers = { 'Content-Type': 'application/json' }
  
  const data = {
    method: 'GET',
    headers: headers,
    timeout: 5000,
  }
  
  try {
    const res = await fetch(url, data)
    
    if (res.status === 204) {
      return {}
    }

    return await res.json()
  } catch (error) {
    throw new Error(`[GloboID.JS] API error: ${error.message}`)
  }
}

export { getClientSettings }
